var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line',{staticClass:"gantt-elastic__today-line",style:(_vm.root.style['chart-today-line']),attrs:{"x1":_vm.task.x,"y1":0,"x2":_vm.task.x,"y2":_vm.root.state.options.allVisibleTasksHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }